



















import { defineComponent, PropType, toRefs, watch } from '@nuxtjs/composition-api'

import useI18n from '@/composables/use-i18n'
import useProxyValue from '@/composables/use-proxy-value'

import CustomSelectItem from '@/interfaces/CustomSelectItem'

export default defineComponent({
  props: {
    value: {
      type: String as PropType<string | null>,
      default: null,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<'radio' | 'select'>,
      default: 'radio',
    },

  },
  setup (props, { emit }) {
    const i18n = useI18n()
    const label = i18n.t('filter.age.label')

    const { proxyValue } = useProxyValue(toRefs(props).value, emit)
    const list: CustomSelectItem[] = [
      {
        name: String(i18n.t('filter.age.option.under', [3])),
        value: '0,3',
      },
      {
        name: String(i18n.t('filter.age.option.under', [5])),
        value: '0,5',
      },
      {
        name: String(i18n.t('filter.age.option.above', [5])),
        value: '6,100',
      },
    ]
    const selectOptions = [
      { name: label, value: null },
      ...list,
    ]

    watch(proxyValue, (value) => {
      emit('update', list.find(item => value === item.value))
    }, { immediate: true })

    return {
      proxyValue,
      label,
      list,
      selectOptions,
    }
  },
})
